import Controller from "@ember/controller";

export default class EmailDomainController extends Controller {
  get domain() {
    return this.model.domain;
  }
}
